/* eslint-disable max-len */
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      showModalExternalUrl: false,
      selectedField: null,
      selectedIndexField: null,
      showPopover: false,
      showModalNativeButton: false,
      idModalNativeButtonTable: 'modalNativeButton',
      selectedNativeButton: null,
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail']),
    ...mapState('jStoreExperienceManagerV2', [
      'showModalFieldLibrary', 'isShowModalFieldFromGroup', 'showModalExternalApi', 'showModalScriptActionBtn', 'isDataset',
    ]),
  },

  watch: {
    form_data_detail(val) {
      if (val.length > 0) {
        this.setDetail(val[0].columns);
      }
    },

    showModalExternalApi(val) {
      if (val) {
        this.$refs.modalExternalApi.show();
        this.showModalExternalUrl = true;
      } else {
        this.$refs.modalExternalApi.hide();
        this.showModalExternalUrl = false;
      }
    },

    showModalScriptActionBtn(val) {
      if (val) {
        this.$refs.modalScriptActionBtn.show();
      } else {
        this.$refs.modalScriptActionBtn.hide();
      }
    },
  },

  methods: {
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),
    ...mapActions('jStoreJoana', ['getDetailDatasetByGroup']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    ...mapActions('jStoreFormUi', [
      'actionGetDetailForm', 'actionGetDetailMultiForm', 'actionSetForm',
      'actionSetMultiForm', 'actionGetDetailFormData',
    ]),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },

    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$swal({
          title: 'Update',
          text: `Are you sure to update ${this.formDetail.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Update',
          confirmButtonColor: '#42a5ce',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            let res;
            if (!this.isMultipleForm) {
              res = await this.actionSetForm(this.genData);
            } else {
              res = await this.actionSetMultiForm(this.genData);
            }
            if (!res.error) {
              this.setChangesValueView(false);
              const dataFilter = {
                id: [this.$route.params.id],
              };
              const param = {
                limit: 0,
                page: 1,
                filter: JSON.stringify(dataFilter),
              };
              if (!this.isMultipleForm) {
                await this.actionGetDetailForm(param);
              } else {
                await this.actionGetDetailMultiForm(param);
              }
            }
          }
        });
      }
      if (this.$v.dataSetup.$error) {
        this.toggleProblem('Please completed the required Configuration');
      }
    },

    async deleteView(type) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this view?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = this._.cloneDeep(this.formDetail);
          if (type === 'requestor') params.table_requester_view = null;
          else if (type === 'approver') params.table_approver_view = null;
          this.resetData();

          let res;
          if (!this.isMultipleForm) {
            res = await this.actionSetForm(params);
          } else {
            res = await this.actionSetMultiForm(params);
          }
          if (!res.error) {
            this.setChangesValueView(false);
            const dataFilter = {
              id: [this.$route.params.id],
            };
            const param = {
              limit: 0,
              page: 1,
              filter: JSON.stringify(dataFilter),
            };
            if (!this.isMultipleForm) {
              await this.actionGetDetailForm(param);
            } else {
              await this.actionGetDetailMultiForm(param);
            }
            this.toggleConfiguration(false);
          }
        }
      });
    },

    openTableConfiguration() {
      this.isOpenTableConfiguration = true;
      this.toggleConfiguration(true);
    },

    toggleConfiguration(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById('tableConfiguration');
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById('tableConfiguration');
        if (element) element.classList.remove('show-properties-field');

        setTimeout(() => {
          this.isOpenTableConfiguration = false;
        }, 200);
      }
    },

    closeModalFieldLibrary(data) {
      const element = document.getElementById('modalFieldLibrary');
      if (element) element.classList.remove('show');

      if (this.isShowModalFieldFromGroup) {
        if (data) this.setSourceModalFieldLibrary(data);
      } else if (!this.isShowModalFieldFromGroup) {
        if (data && !this.isOpenConfigColumn) {
          const index = this.dataSetup.column.push(data) - 1;
          this.selectedField = this.dataSetup.column[index];
          this.selectedIndexField = index;
          this.isNewField = true;

          setTimeout(() => {
            this.toggleProperties(true);
          }, 200);
        }
      }

      setTimeout(() => {
        this.setShowModalFieldLibrary(false);
        this.setIsShowModalFieldFromGroup(false);
      }, 300);
    },

    submitConfig(params, isCancel, type, sourceType) {
      if (!isCancel) {
        this.dataSetup.auto_show_search_options_list = params.auto_show_search_options_list;
        this.dataSetup.filter = params.filter;
        this.dataSetup.filterOperator = params.filterOperator;
        this.dataSetup.filter_function = params.filter_function;
        this.dataSetup.search_options_list = params.search_options_list;
        this.dataSetup.server_side_pagination = params.server_side_pagination;
        this.dataSetup.sorting = params.sorting;
        this.dataSetup.title = params.title;
        this.dataSetup.config_preview_data = {
          is_show_summary_data: params.config_preview_data.is_show_summary_data,
          summary_data: params.config_preview_data.is_show_summary_data && params.config_preview_data.summary_data ? params.config_preview_data.summary_data : '',
          summary_label: params.config_preview_data.is_show_summary_data ? params.config_preview_data.summary_label : '',
          is_show_summary_list: params.config_preview_data.is_show_summary_list,
          summary_list_type: params.config_preview_data.is_show_summary_list ? params.config_preview_data.summary_list_type : null,
          summary_list: params.config_preview_data.is_show_summary_list ? params.config_preview_data.summary_list : [],
        };
        this.dataSetup.row_expansion = params.row_expansion;
        this.dataSetup.rows_page_default = params.rows_page_default;
        this.dataSetup.rows_page_option = params.rows_page_option.filter(i => i !== '').map(i => Number(i));
        this.dataSetup.freeze_header_table = params.freeze_header_table;
        this.dataSetup.config_tag_filter = params.config_tag_filter;
        this.dataSetup.disable_redirect_detail_page = params.disable_redirect_detail_page;

        if (type === 'default') {
          this.dataSetup.is_use_bulking_update = sourceType !== 'dataset' ? params.is_use_bulking_update : false;
          this.dataSetup.is_use_bulking_delete = sourceType === 'form' ? params.is_use_bulking_delete : false;

          if (params.is_use_bulking_update && sourceType !== 'dataset') {
            this.dataSetup.column_bulking_update = params.column_bulking_update.length > 0 ? params.column_bulking_update[0] : null;
          } else {
            this.dataSetup.column_bulking_update = null;
          }
        } else if (type === 'requestor' || type === 'approver') {
          this.dataSetup.isHideCheckbox = params.isHideCheckbox;
          this.dataSetup.is_use_bulking_delete = sourceType === 'form' ? params.is_use_bulking_delete : false;
        }

        this.setChangesValueView(true);
      }
    },

    openModalNativeButtonTable(status, button) {
      if (status && button) {
        this.showModalNativeButton = true;
        this.selectedNativeButton = button;
        setTimeout(() => {
          const element = document.getElementById(this.idModalNativeButtonTable);
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById(this.idModalNativeButtonTable);
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.showModalNativeButton = false;
          this.selectedNativeButton = null;
        }, 200);
      }
    },

    closeModalNativeButtonTable() {
      this.openModalNativeButtonTable(false);
    },

    submitNativeButtonTable(params) {
      this.dataSetup.config_native_button_table[this.selectedNativeButton].label = params.label;
      this.dataSetup.config_native_button_table[this.selectedNativeButton].is_hidden = params.is_hidden;
      this.openModalNativeButtonTable(false);
      this.setChangesValueView(true);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixTableView.js